import { __awaiter } from "tslib";
import { InterconsultService } from "@/servicesTs/models/interconsult/interconsult";
const moduleSideMenu = {
    namespaced: true,
    state: {
        cantInterconsultPendings: 0,
        cantInterconsultPendingsLoading: false,
    },
    getters: {
        getCantInterconsultPendings(state) {
            return state.cantInterconsultPendings;
        },
        getCantInterconsultPendingsLoading(state) {
            return state.cantInterconsultPendingsLoading;
        },
    },
    mutations: {
        loadCantInterconsultPendings(state, cantInterconsultPendings) {
            state.cantInterconsultPendings = cantInterconsultPendings;
        },
        setCantInterconsultPendingsLoading(state, cantInterconsultPendingsLoading) {
            state.cantInterconsultPendingsLoading = cantInterconsultPendingsLoading;
        },
    },
    actions: {
        loadCantInterconsultPendings({ commit }, filter) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    commit("setCantInterconsultPendingsLoading", true);
                    commit("loadCantInterconsultPendings", 0);
                    const count = yield InterconsultService.countInterconsultFilter(filter);
                    commit("loadCantInterconsultPendings", count.data.interconsults);
                }
                catch (error) {
                    console.log(error);
                }
                finally {
                    commit("setCantInterconsultPendingsLoading", false);
                }
            });
        },
    },
};
export default moduleSideMenu;
